import { Box, Link } from '@mui/material'
import ArrowRightIcon from '@mui/icons-material/ArrowRight'

interface BreadcrumbItem {
    label: string
    url: string
}

interface BreadcrumbsProps {
    slugs?: string[]
    rootUrl: string | URL
    color?: string
}

function toLabel(part: string): string {
    return part
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ')
}

function buildBreadcrumbs(slugs: string[], rootUrl: string | URL): BreadcrumbItem[] {
    const items: BreadcrumbItem[] = [{ label: 'Home', url: rootUrl.toString() }]
    let currentUrl = ''

    slugs.forEach((part) => {
        if (part === 'home') return
        currentUrl += `/${part}`
        items.push({ label: toLabel(part), url: `${rootUrl}${currentUrl}` })
    })
    return items
}

const Index = ({ slugs = [], rootUrl, color = 'inherit' }: BreadcrumbsProps) => {
    const isHidden = slugs.length === 1 && slugs[0] === 'home'
    const breadcrumbs = buildBreadcrumbs(slugs, rootUrl)
    const breadcrumbStructuredData = {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: breadcrumbs.map((item, index) => ({
            '@type': 'ListItem',
            position: index + 1,
            name: item.label,
            item: item.url,
        })),
    }

    return (
        <>
            <script
                type='application/ld+json'
                dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbStructuredData) }}
            />
            <Box
                component='nav'
                aria-label='Breadcrumbs'
                sx={{
                    display: isHidden ? 'none' : 'flex',
                    position: 'relative',
                    overflowX: 'auto',
                    whiteSpace: 'nowrap',
                    justifyContent: 'start',
                    mb: 1,
                    pl: { xs: 2, md: 5 },
                    maxWidth: '100%',
                    '&::-webkit-scrollbar': {
                        display: 'none',
                    },
                    '&::-webkit-scrollbar-track': {
                        display: 'none',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        display: 'none',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        display: 'none',
                    },
                }}
            >
                <ul style={{ display: 'flex', listStyle: 'none', padding: 0, margin: 0, width: 'max-content' }}>
                    {breadcrumbs.map((item, index) => (
                        <li
                            key={item.url}
                            style={{ display: 'flex', alignItems: 'center' }}
                        >
                            {breadcrumbs.length > 1 && index > 0 && <ArrowRightIcon color={color as any} />}
                            <Link
                                underline='hover'
                                color={index === breadcrumbs.length - 1 ? color as any : 'info'}
                                href={item.url}
                                style={{
                                    textDecoration: 'none',
                                    fontSize: '0.9rem',
                                    fontFamily: 'MonaSansCondensed, sans-serif',
                                }}
                                aria-current={index === breadcrumbs.length - 1 ? 'page' : undefined}
                            >
                                {item.label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </Box>
        </>
    )
}

export default Index

